/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import type Track from 'bundles/interactive-transcript/models/Track';

type Props = {
  track: Track;
};

const PlainTextTranscript = ({ track }: Props) => {
  if (!Array.isArray((track || {}).cues)) {
    return null;
  }

  const { cues } = track;

  return (
    <Typography2 component="p" variant="bodyPrimary" data-testid="plainTextTranscript">
      {cues
        .filter((c) => !c.hideForTrimmingRange)
        .map((cue) => cue.text)
        .join('  ')}
    </Typography2>
  );
};

export default PlainTextTranscript;
